<template>
    <div class="material-container">
        <ul class="material-box">
            <li class="image-part">
                <img :src="src" class="product-img">
            </li>

            <li class="name-part">
                <span>{{obj.productname}}</span>
            </li>

            <li class="price-part">
                <span class="price">${{obj.cost}} {{unit}}</span>
            </li>

            <li class="btn-part">
                <button class="ask-btn" @click="throwAskEvent">{{btnName}}</button>
            </li>
        </ul>
    </div>
</template>

<script setup>
    import {getCurrentInstance, computed} from "vue";
    import myUtil from "@/util/util";

    const { proxy } = getCurrentInstance();

    const props = defineProps(['obj'])
    const emits = defineEmits(['clickAskBtn'])

    const src = computed(() => {
        if (null == props.obj){
            return ""
        }else{
            return myUtil.generateProductImg(props.obj)
        }
    })

    const unit = computed(() => {
        if (null == props.obj || null == props.obj.unit || "" === props.obj.unit){
            return ""
        }else{
            return "/ " + props.obj.unit
        }
    })

    const btnName = computed(() => {
        if (null != props.obj.bcatacode2 && props.obj.bcatacode2.substring(0, 2) === "02"){
            return "詢問"
        }else{
            return "購買"
        }
    })

    function throwAskEvent() {
        emits("clickAskBtn", props.obj)
    }
</script>

<style scoped>
    .material-container {
        width: 100%;
        text-align: center;
    }

    .material-box {
        width: 90%;
        margin: auto;
        list-style: none;
        padding-left: 0;
    }

    .product-img {
        border: 1px #e5e5e5 solid;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .ask-btn{
        font-size: 12px;
        width: 100%;
    }

    .price-part {
        margin-top: 6px;
        margin-bottom: 2px;
    }

    .price-part .price {
        font-weight: 600;
        font-size: 14px;
        color: #e83f33;
    }

    .btn-part {
        padding: 4px;
        overflow: hidden;
    }

    .name-part {
        margin-top: 12px;
        margin-bottom: 6px;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.5em;
        height: 3em;
        overflow: auto;
        white-space: inherit;
    }

    .image-part {
        position: relative;
        padding-top: 100%;
        width: 100%;
        height: 0;
    }
</style>